import React, { useState } from 'react';
import { EllipsisIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/components/capstone/base';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import {
  DropdownDialog,
  DropdownBody,
  DropdownList,
  DropdownListItem,
} from '@rsos/components/capstone/base/Dropdown/DropdownComponents';
import DeleteRole from '../../DeleteRole';
import {
  RoleLimitReached,
  DropdownListItemDisabled,
} from './RoleActionControl.styles';

const RoleActionControl = ({
  onDuplicate,
  role,
  isMaxRolesCountReached,
  isDuplicateInProgress,
}) => {
  const [isDeleteRoleModalOpened, setIsDeleteModalOpened] = useState(false);

  const handleDuplicate = onDropdownClose => {
    onDuplicate(role.id);
    onDropdownClose();
  };
  const handleOpenModal = onDropdownClose => {
    setIsDeleteModalOpened(true);
    onDropdownClose();
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpened(false);
  };

  return (
    <>
      <Dropdown triggerElement={EllipsisMenu} triggerOnClose zIndex={1}>
        {onDropdownClose => (
          <DropdownDialog top={35} left={6} width="180px">
            <DropdownBody>
              <DropdownList borderless>
                {isMaxRolesCountReached ? (
                  <DropdownListItem>
                    <RoleLimitReached>
                      You have reached the max amount of roles
                    </RoleLimitReached>
                  </DropdownListItem>
                ) : isDuplicateInProgress ? (
                  <DropdownListItemDisabled>
                    Duplicate Role
                  </DropdownListItemDisabled>
                ) : (
                  <DropdownListItem
                    onClick={() => handleDuplicate(onDropdownClose)}
                  >
                    Duplicate Role
                  </DropdownListItem>
                )}
                <DropdownListItem
                  onClick={() => handleOpenModal(onDropdownClose)}
                >
                  Delete Role
                </DropdownListItem>
              </DropdownList>
            </DropdownBody>
          </DropdownDialog>
        )}
      </Dropdown>
      <DeleteRole
        isOpened={isDeleteRoleModalOpened}
        onClose={handleCloseModal}
        role={role}
      />
    </>
  );
};

export default RoleActionControl;

export function EllipsisMenu({ selected, onClick }) {
  return (
    <Button
      btnType="tertiary"
      size="xsmall"
      onClick={onClick}
      selected={selected}
      type="button"
    >
      <EllipsisIcon
        viewboxWidth={140}
        viewboxHeight={140}
        width={14}
        height={14}
      />
    </Button>
  );
}
